export default __webpack_public_path__ + "static/media/img-slider-scb-anywhere-3.7f08d3c5.png";